// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".facesheet-screenings-history-mode .screenings-submissions>.row{margin:0 0 1rem !important;padding:0}.facesheet-screenings-history-mode .screenings-submissions .form-name{margin:0;font-size:1rem;font-weight:400;line-height:1.5rem;font-family:inherit}", ""]);
// Exports
module.exports = exports;
